import React, { useState, useEffect } from 'react'
import PageLayout from './common/layout/PageLayout'
import MarkdownRenderer from './common/MarkdownRenderer'
import './LegalDocument.css'

function SMSNotificationsDisclosure() {
  const [content, setContent] = useState('')

  useEffect(() => {
    fetch('/legal/sms_notifications_disclosure.md')
      .then((response) => response.text())
      .then((text) => setContent(text))
      .catch((error) =>
        console.error('Error loading SMS Notifications Disclosure:', error),
      )
  }, [])

  return (
    <PageLayout
      title="SMS Notifications Disclosure"
      noCard={true}
      heroContent={<></>}
      showHeader={false}
    >
      <div className="legal-page-wrapper">
        <div className="legal-document">
          {content ? (
            <MarkdownRenderer content={content} />
          ) : (
            <p>Loading SMS Notifications Disclosure...</p>
          )}
        </div>
      </div>
    </PageLayout>
  )
}

export default SMSNotificationsDisclosure
